import { render, staticRenderFns } from "./MensaDish.vue?vue&type=template&id=997cf2a8&scoped=true&"
import script from "./MensaDish.vue?vue&type=script&lang=js&"
export * from "./MensaDish.vue?vue&type=script&lang=js&"
import style0 from "./MensaDish.vue?vue&type=style&index=0&id=997cf2a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997cf2a8",
  null
  
)

export default component.exports